import React from 'react';
import { ReactSelectComponents, Spacer, Text } from '@Sage/hoi-poi-ui';
import LabelPopover from 'components/LabelPopover';

function findOptionByValue(options, valueId) {
    if (!options || valueId == null) return null;
    for (const item of options) {
        if (item.options) {
            const found = findOptionByValue(item.options, valueId);
            if (found) return found;
        } else if (Number(item.value) === Number(valueId) || item.value === valueId) {
            return item;
        }
    }
    return null;
}

export const createSingleValueComponent = (getExtraClassNameValue, popoverConfig) => {
    const hasPopover = popoverConfig?.parseDataForPopover && popoverConfig.type;

    return (singleValueProps) => {
        const { data, selectProps } = singleValueProps;
        const valueId = data?.value ?? data?.id;
        const optionsSource = selectProps?.options ?? selectProps?.menuProps?.options ?? null;
        const fullOption =
            optionsSource && valueId != null ? findOptionByValue(optionsSource, valueId) : null;
        const optionForClass = fullOption ?? data;
        const extraClassName =
            getExtraClassNameValue && optionForClass ? getExtraClassNameValue(optionForClass) : '';
        const id = data?.value ?? data?.id;

        const valueAvatar =
            popoverConfig?.getImageForValue?.(id) ??
            (popoverConfig?.getImage ? popoverConfig.getImage(id) : null);

        const labelClassName = ['fm-select-row__label', extraClassName].filter(Boolean).join(' ');
        const labelNode = (
            <Text type="body" isTruncated useTooltip className={labelClassName}>
                {data.label}
            </Text>
        );

        const content = valueAvatar ? (
            <div className="fm-select-row--flex fm-select-row--selected">
                <div className="fm-select-row__icon">{valueAvatar}</div>
                <div className="fm-select-row__content">{labelNode}</div>
            </div>
        ) : (
            <span className={extraClassName}>{data.label}</span>
        );

        if (!hasPopover || id == null) {
            return (
                <ReactSelectComponents.SingleValue {...singleValueProps}>
                    {content}
                </ReactSelectComponents.SingleValue>
            );
        }

        const image = popoverConfig.getImage ? popoverConfig.getImage(id) : popoverConfig.image;

        return (
            <ReactSelectComponents.SingleValue {...singleValueProps}>
                <LabelPopover
                    id={id}
                    type={popoverConfig.type}
                    data={popoverConfig.remotePopover ? undefined : data}
                    remotePopover={popoverConfig.remotePopover}
                    parseDataForPopover={popoverConfig.parseDataForPopover}
                    image={image}
                >
                    {content}
                </LabelPopover>
            </ReactSelectComponents.SingleValue>
        );
    };
};

export const createMultiValueLabelComponent = (popoverConfig) => {
    const hasPopover = popoverConfig?.parseDataForPopover && popoverConfig.type;

    return (multiValueLabelProps) => {
        const { data } = multiValueLabelProps;
        const id = data?.value ?? data?.id;

        const valueAvatar =
            hasPopover &&
            (popoverConfig?.getImageForValue?.(id) ??
                (popoverConfig?.getImage ? popoverConfig.getImage(id) : null));

        const labelContent = valueAvatar ? (
            <div className="fm-select-row--flex">
                <div className="fm-select-row__icon">{valueAvatar}</div>
                <Spacer x={1} />
                <div className="fm-select-row__content">{data.label}</div>
            </div>
        ) : (
            data.label
        );

        if (!hasPopover || id == null) {
            return (
                <ReactSelectComponents.MultiValueLabel {...multiValueLabelProps}>
                    {labelContent}
                </ReactSelectComponents.MultiValueLabel>
            );
        }

        const image = popoverConfig.getImage ? popoverConfig.getImage(id) : popoverConfig.image;

        return (
            <ReactSelectComponents.MultiValueLabel {...multiValueLabelProps}>
                <LabelPopover
                    id={id}
                    type={popoverConfig.type}
                    data={popoverConfig.remotePopover ? undefined : data}
                    remotePopover={popoverConfig.remotePopover}
                    parseDataForPopover={popoverConfig.parseDataForPopover}
                    image={image}
                >
                    {labelContent}
                </LabelPopover>
            </ReactSelectComponents.MultiValueLabel>
        );
    };
};
